export default __webpack_public_path__ + "static/media/ic_16_close.899b3058.svg";